export default "__VITE_ASSET__CzKX1YDS__"